define(["angular", "../translate/translate", "angular-click-outside"], function (angular) {
    "use strict";
    return angular.module("menuModule", ["translateModule", "tw.directives.clickOutside", "positionModule"]);
});